import {DATE_VALIDATION_TYPE} from '@/utils/constants/commonConstants';
import {COLOR} from '@/utils/constants/colors';
import {SIZE} from '@/utils/constants/globalStyle';

const START_BEFORE_END_MSG =
  'Please select a start date before selecting an end date.';
const END_DATE_REQUIRED_MSG = 'Please select an end date.';
const END_BEFORE_START_MSG = 'End date cannot be earlier than the start date.';
const SELECT_START_FIRST_MSG = 'Select a start date first.';

export const futureDateRules = (msg) => [
  {
    type: DATE_VALIDATION_TYPE.START_DATE,
    msg,
    excludeLabel: true
  },
  {
    type: DATE_VALIDATION_TYPE.START_DATE_TODAY,
    msg,
    excludeLabel: true
  }
];

const placeholderFromLabel = (label = '') =>
  label.endsWith(' *') ? label.slice(0, -2) : label;

export const baseDateSchema = ({className, label, ...rest}) => ({
  placeholder: placeholderFromLabel(label),
  className,
  label,
  isDark: true,
  required: false,
  ...rest
});

export const getActiveStartDateSchema = (endDate) =>
  baseDateSchema({
    className: 'box-size-width z-50',
    label: 'Active Start Date *',
    dependentDate: [endDate],
    validationRules: [
      {
        type: DATE_VALIDATION_TYPE.START_DATE_REQUIRED_IF_END_DATE,
        endDate,
        msg: START_BEFORE_END_MSG,
        excludeLabel: true
      },
      ...futureDateRules('Start date must be a future date.')
    ]
  });

export const getActiveEndDateSchema = (startDate) =>
  baseDateSchema({
    className: 'box-size-width z-45',
    label: 'Active End Date *',
    dependentDate: [startDate],
    disabled: !startDate,
    disabledHelperText: SELECT_START_FIRST_MSG,
    validationRules: [
      {
        type: DATE_VALIDATION_TYPE.END_DATE_REQUIRED_IF_START_DATE,
        startDate,
        msg: END_DATE_REQUIRED_MSG,
        excludeLabel: true
      },
      ...futureDateRules('End date must be a future date.'),
      {
        type: DATE_VALIDATION_TYPE.END_DATE,
        msg: END_BEFORE_START_MSG,
        startDate,
        excludeLabel: true
      }
    ]
  });

export const getRewardDateSchema = () =>
  baseDateSchema({
    className: 'box-size-width z-40',
    label: 'Reward Date *',
    validationRules: [
      {type: 'required', msg: ' is required'},
      ...futureDateRules('Reward date must be a future date.')
    ]
  });

export const getDisplayStartDateSchema = (displayEndDate) =>
  baseDateSchema({
    className: 'box-size-width z-35',
    label: 'Display Start Date *',
    dependentDate: [displayEndDate],
    validationRules: [
      {
        type: DATE_VALIDATION_TYPE.START_DATE_REQUIRED_IF_END_DATE,
        endDate: displayEndDate,
        msg: START_BEFORE_END_MSG,
        excludeLabel: true
      },
      ...futureDateRules('Start date must be a future date.')
    ]
  });

export const getDisplayEndDateSchema = (displayStartDate) =>
  baseDateSchema({
    className: 'box-size-width z-30',
    label: 'Display End Date *',
    dependentDate: [displayStartDate],
    disabled: !displayStartDate,
    disabledHelperText: SELECT_START_FIRST_MSG,
    validationRules: [
      {
        type: DATE_VALIDATION_TYPE.END_DATE_REQUIRED_IF_START_DATE,
        startDate: displayStartDate,
        msg: END_DATE_REQUIRED_MSG,
        excludeLabel: true
      },
      ...futureDateRules('End date must be a future date.'),
      {
        type: DATE_VALIDATION_TYPE.END_DATE,
        msg: END_BEFORE_START_MSG,
        startDate: displayStartDate,
        excludeLabel: true
      }
    ]
  });

export const targetNameUiSchema = {
  className: 'box-size-width text-sm',
  isDark: true,
  placeholder: 'Name',
  validationRules: [
    {type: 'required', msg: ` is required`},
    {
      type: 'noSpecialChar',
      msg: `Please use alphanumeric values to enter a valid name`,
      excludeLabel: true
    }
  ]
};

export const hasDisplayDateToggleSchema = {
  label: 'Active and Display the same?',
  isDark: true,
  showCheckedIcon: false
};

export const awardPointsToggleSchema = {
  label: 'Award Point when Target is Met',
  isDark: true,
  showCheckedIcon: false
};

export const joinPerfectStoreToggleSchema = {
  label: 'Required User to join Perfect Store Target?',
  isDark: true,
  showCheckedIcon: false
};

export const uploadTemplateButtonSchema = {
  className: 'butt-size w-full justify-center text-center',
  title: 'Upload Template',
  size: SIZE.SMALL,
  variant: COLOR.SECONDARY
};
